module.exports = {"player":{"state":{"error":"Something went wrong, please try again later or contact support.","loading":"LOADING"},"controls":{"volumen":{"label-icon":"Volume","label-up":"Volume Up","label-down":"Volumen Down"},"presentation-mode":{"label-prev":"Previous Scene","label-next":"Next Scene"}},"watermark":{"text":"Create your wideo!"}}}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en/player.json
// module id = 784
// module chunks = 32